import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomerCenterService } from "../../../services";
import TopSetion from '../../../components/customer-service-center/TopSetion';
import SubHeading from '../../../components/customer-service-center/SubHeading';
import passwordIcon from '../../../assets/img/customer-service-center/password-lock.png';

const SecretPost = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const handleConfirm = async (e) => {
        e.preventDefault();
        if (!password || password.trim() === '') {
            setError('비밀번호를 입력해주세요.');
            return;
        }
        try {
            const response = await CustomerCenterService.validateInquiryPassword(id, { password });
            console.log(response);
            navigate(`/inquiry-details/${id}`);
        } catch (error) {
            console.log(error);
            setError('비밀번호가 일치하지 않습니다.');
        }
    };

    return (
        <>
            <div className="announcement-list-page">
                <TopSetion />

                {/* Main Content */}
                <main className="main-content">
                    <SubHeading heading="문의하기" />

                    <section className="contact-us-secret-section">
                        <div className="secret-post-inner">
                            <div className="secret-header">
                                <img className="lock-illustration" src={passwordIcon} alt="lock" />
                                <h2 className="secret-title">비밀글 보기</h2>
                                <p className="secret-desc">이 글은 비밀글입니다. 비밀번호를 입력하여 주세요.</p>
                            </div>

                            <form className="secret-form" onSubmit={handleConfirm}>
                                <div className="form-group">
                                    <input
                                        type="password"
                                        className="secret-input"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    {error && <span className="input-error-message">{error}</span>}
                                </div>

                                <div className="secret-actions">
                                    <button
                                        type="button"
                                        className="search-button list-button"
                                        onClick={() => navigate('/contact-us')}
                                    >
                                        목록
                                    </button>
                                    <button type="submit" className="search-button green-button confirm-button">확인</button>
                                </div>
                            </form>
                        </div>
                    </section>
                </main>
            </div >
        </>
    );
};

export default SecretPost;